var map = {
	"./ArrowLeft.vue": "4775",
	"./ArrowRight.vue": "1295",
	"./Close.vue": "e33f",
	"./Copy.vue": "a054",
	"./DoubleArrowRight.vue": "51a8",
	"./Exit.vue": "d4aa",
	"./Exit2.vue": "598e",
	"./Faq.vue": "4d6e",
	"./Feedback.vue": "4ae8",
	"./List.vue": "8e1c",
	"./Loading.vue": "19dc",
	"./Lock.vue": "d1a3",
	"./Profile.vue": "f248",
	"./Question.vue": "3414",
	"./Reviews.vue": "9bff",
	"./Search.vue": "79bc4",
	"./Users.vue": "c313",
	"./Vk.vue": "d817"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f562";